/**
 * Privacy policy — static page for the seeded Navarasam reunion site.
 *
 * The content here is the operator's commitment; rewrite as needed
 * before opening signups beyond the trusted batch. Lawyer-reviewed
 * copy can replace this once available.
 */

import { Link } from 'react-router';

export function PrivacyPage() {
  return (
    <article className="container mx-auto px-4 py-16 max-w-3xl">
      <h1 className="text-4xl font-display font-bold text-white mb-3">Privacy Policy</h1>
      <p className="text-white/40 text-sm mb-10">Last updated 2026-05-13</p>

      <section className="prose prose-invert max-w-none">
        <p>
          Re:Nav-96 is a private community site for the Navarasam School Class of 1996. We
          collect only the information our members give us; we don't sell, rent, or share
          your data with third-party advertisers.
        </p>

        <h2>What we collect</h2>
        <ul>
          <li><strong>Account info:</strong> name, email, optional phone — required so you can sign in and we can email you about the reunion.</li>
          <li><strong>Photos and messages</strong> you upload to the gallery and message boards.</li>
          <li><strong>OAuth profile info</strong> from Google/Microsoft when you sign in with those providers — limited to your email, display name, and avatar.</li>
          <li><strong>Operational logs:</strong> IP address, browser, and request paths, kept for at most 30 days and used only to triage bugs and abuse.</li>
        </ul>

        <h2>How we use it</h2>
        <ul>
          <li>To authenticate you and authorise what you can see and do.</li>
          <li>To deliver event invites, weekly digests (opt-in only), and password resets.</li>
          <li>To moderate content, enforce membership policy, and respond to your requests.</li>
        </ul>

        <h2>What we don't do</h2>
        <ul>
          <li>We don't sell personal data, ever.</li>
          <li>We don't run third-party advertising trackers or analytics on this site.</li>
          <li>We don't keep credit-card information; payments (if any) are processed by the payment provider directly.</li>
        </ul>

        <h2>Your rights</h2>
        <p>
          You can edit your profile, change your password, or delete your account from{' '}
          <Link to="/member/settings" className="link">Settings</Link>. Account deletion
          permanently removes your personal info and authored content (photos, messages,
          tickets) from this system; backups are purged within 30 days.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy questions, reach an admin via the{' '}
          <Link to="/contact" className="link">contact form</Link>.
        </p>
      </section>
    </article>
  );
}

export default PrivacyPage;
